import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { HistoryComponent } from './history/history.component';

import { SharedModule } from './shared/shared.module';
import { DateAgoPipe } from './pipes/date-ago.pipe';
import { LevelExtractPipe } from './pipes/level-extract.pipe';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    HistoryComponent,
    DateAgoPipe, LevelExtractPipe
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    BrowserAnimationsModule,
    ConfirmDialogModule,
    SharedModule,
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot([
      { path: 'apphome', component: HomeComponent, pathMatch: 'full' },
      { path: 'history', component: HistoryComponent, pathMatch: 'full' },
    { path: 'counter', component: CounterComponent },
    { path: 'fetch-data', component: FetchDataComponent },
    ]//, { relativeLinkResolution: 'legacy' }
    )
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
